module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_46.c1379a26.png";